var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-6"},[_c('h1',{staticClass:"mb-5"},[_vm._v(" "+_vm._s(_vm.$t('global.adminConsole'))+": "+_vm._s(_vm.$t('global.notificationDispatcher.delayConfiguration'))+" ")]),_c('NotificationDelaysTable',{attrs:{"notificationDelays":_vm.defaultDelaysWithIds,"updateFunction":_vm.updateDefaultNotificationClassDelays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }